
import { Chip } from '@mui/material';

export const ContractStateChip = ({ value }) => {
  const state = value?.toString();
  let label = "Desconocido";
  let sx = {};

  switch (state) {
    case "0":
      label = "En curso";
      sx = {
        border: '1px solid green',
        color: '#fff',
        backgroundColor: 'green',
        fontWeight: 'bold'
      };
      break;
    case "1":
      label = "Baja";
      sx = {
        border: '1px solid blue',
        color: '#fff',
        backgroundColor: 'blue',
        fontWeight: 'bold'
      };
      break;
    case "2":
      label = "Vencido";
      sx = {
        border: '1px solid red',
        color: '#fff',
        backgroundColor: 'red',
        fontWeight: 'bold'
      };
      break;
    default:
      sx = {
        border: '1px solid grey',
        color: '#fff',
        backgroundColor: 'grey'
      };
      break;
  }

  return <Chip label={label} size="small" sx={sx} />;
};
